module.exports = __webpack_public_path__ + "media/savings_calculator/fin_aid_advice-09735cc9.png";